import React from "react";
import "./Button.scss";
import Loader from "../Loader/Loader";
import mixpanelService from "../../Services/mixpanelService";
import mixpanelEvents, { getScreenName } from "../../../config/mixpanelEvents";

interface ButtonFields {
  btnName: string;
  disabled?: boolean;
  isLoading?: boolean | undefined;
  isSecondary?: boolean;
  isLightBlue?: boolean;
  type?: string;
  isTick?: boolean;
  isWhatsapp?: boolean;
  isUpload?: boolean;
  isAdd?: boolean;
  prefix?: any;
  clicked?: boolean;
  onClick?: (value: any) => void;
  parentClassName?: string;
  ariaLabel?: string;
}

function trackCtaClick(props: any, event: any) {
  try {
    const screen_name = getScreenName(window.location.pathname);
    if (screen_name) {
      mixpanelService({
        event: mixpanelEvents.CTA_CLICKED,
        screen_name,
        text: props.btnName,
        cta_type: "sticky",
        cta_class: props.isSecondary || props.isLightBlue ? "secondary" : "primary",
        cta_service: "AOJ",
      });
    }
  } catch (e) {
    console.error("mixpanel cta_clicked failed", e);
  }
  props.onClick?.(event);
}

const Button: React.FC<ButtonFields> = (props: any) => (
  <button
    className={
      "btn " +
      (props.isSecondary ? "isSecondary " : "") +
      (props.isLightBlue ? "isLightBlue " : "") +
      (props.disabled || props.isLoading ? "disable" : "active") +
      (props?.parentClassName ? props?.parentClassName : "")
    }
    disabled={props.disabled}
    onClick={(event) => trackCtaClick(props, event)}
    type={props.type || "button"}
    aria-busy={props.isLoading || undefined}
    aria-label={props.ariaLabel || props.btnName || undefined}
  >
    {props.prefix && props.prefix}
    {props.isLoading ? (
      <>
        <Loader announce size={20} />
        <span className="sr-only">{props.btnName || "Loading"}</span>
      </>
    ) : props.isTick ? (
      <>
        {" "}
        <span className="edel-icon-tick" aria-hidden="true" /> {props.btnName}
      </>
    ) : (
      `${props.btnName}`
    )}
  </button>
);

export const DashedButton: React.FC<ButtonFields> = (props: any) => (
  <button
    className={"addBtn " + (props.disabled ? "dasDisable" : "dasActive")}
    disabled={props.disabled}
    onClick={(event) => trackCtaClick(props, event)}
    type={props.type || "button"}
    aria-busy={props.isLoading || undefined}
    aria-label={props.ariaLabel || props.btnName || undefined}
  >
    {/* {props.btnName}
        {props.isLoading && <Loader announce size={20} />} */}
    {props.isLoading ? (
      <>
        <Loader announce size={20} />
        <span className="sr-only">{props.btnName || "Loading"}</span>
      </>
    ) : props.isAdd ? (
      <>
        {" "}
        <span className="edel-icon-plus" aria-hidden="true" /> {props.btnName}
      </>
    ) : (
      `${props.btnName}`
    )}
  </button>
);

export const TransparentButton: React.FC<ButtonFields> = (props: any) => (
  <button
    className={"trnsBtn " + props.disabled}
    disabled={props.disabled}
    onClick={(event) => trackCtaClick(props, event)}
    type={props.type || "button"}
    aria-busy={props.isLoading || undefined}
    aria-label={props.ariaLabel || props.btnName || (props.isUpload ? "Upload" : props.isWhatsapp ? "WhatsApp" : undefined)}
  >
    {props.prefix && props.prefix}
    {props.isWhatsapp ? (
      <>
        {" "}
        <span className="edel-icon-whatsapp" aria-hidden="true" />{" "}
      </>
    ) : null}
    {props.isUpload ? (
      <>
        {" "}
        <span className="edel-icon-upload" aria-hidden="true" />{" "}
      </>
    ) : null}
    {props.isLoading ? (
      <>
        <Loader announce size={20} />
        <span className="sr-only">{props.btnName || "Loading"}</span>
      </>
    ) : props.isTick ? (
      <>
        {" "}
        <span className="edel-icon-tick" aria-hidden="true" /> {props.btnName}
      </>
    ) : (
      `${props.btnName}`
    )}
  </button>
);

export const SubmitButton: React.FC<ButtonFields> = (props: any) => (
  <button
    className={"submitBtn " + (props.disabled ? "disable" : "active")}
    disabled={props.disabled}
    onClick={(event) => trackCtaClick(props, event)}
    type={props.type || "submit"}
    aria-busy={props.isLoading || undefined}
    aria-label={props.ariaLabel || props.btnName || undefined}
  >
    {props.isLoading ? (
      <>
        <Loader announce size={20} />
        <span className="sr-only">{props.btnName || "Loading"}</span>
      </>
    ) : props.isTick ? (
      <>
        {" "}
        <span className="edel-icon-tick" aria-hidden="true" /> {props.btnName}
      </>
    ) : (
      `${props.btnName}`
    )}
  </button>
);

export const Verify: React.FC<ButtonFields> = (props: any) => (
  <button
    className={
      "btn vrfyBtn " +
      (props.disabled || props.isLoading ? "disable" : "active")
    }
    disabled={props.disabled}
    onClick={(event) => trackCtaClick(props, event)}
    type={props.type || "button"}
    aria-busy={props.isLoading || undefined}
    aria-label={props.ariaLabel || props.btnName || undefined}
  >
    {props.isLoading ? (
      <>
        <Loader announce size={20} />
        <span className="sr-only">{props.btnName || "Loading"}</span>
      </>
    ) : props.isTick ? (
      <>
        {" "}
        <span className="edel-icon-tick" aria-hidden="true" />
        {props.btnName}
      </>
    ) : (
      `${props.btnName}`
    )}
  </button>
);

export const LightBlueButton: React.FC<ButtonFields> = (props: any) => (
  <button
    className={
      "LightBluebtn info alignBtn " + (props.clicked ? "selected" : "")
    }
    disabled={props.disabled}
    onClick={(event) => trackCtaClick(props, event)}
    type={props.type || "button"}
    aria-busy={props.isLoading || undefined}
    aria-label={props.ariaLabel || props.btnName || (props.isUpload ? "Upload" : props.isWhatsapp ? "WhatsApp" : undefined)}
  >
    {props.prefix && props.prefix}
    {props.isWhatsapp ? (
      <>
        {" "}
        <span className="edel-icon-whatsapp" aria-hidden="true" />{" "}
      </>
    ) : null}
    {props.isUpload ? (
      <>
        {" "}
        <span className="edel-icon-upload" aria-hidden="true" />{" "}
      </>
    ) : null}
    {props.isLoading ? (
      <>
        <Loader announce size={20} />
        <span className="sr-only">{props.btnName || "Loading"}</span>
      </>
    ) : props.isTick ? (
      <>
        {" "}
        <span className="edel-icon-tick" aria-hidden="true" /> {props.btnName}
      </>
    ) : (
      `${props.btnName}`
    )}
  </button>
);

export default Button;
